"use client";
import React, { useState } from "react";
import Footer from "./Footer.component";
import { useDispatch } from "react-redux";
import { openPopup } from "@/redux/slices/popupSlice";
import LeadService from "@/utils/api/leadService";
import {
  SOCIAL_MEDIA_INFORMATION,
  COMPANY_SITE_DATA,
  COMPANY_VEHICLE_SITE_DATA,
  LOCATION_INFO,
} from "./constants";
import { showSnackbar } from "@/redux/slices/snackbarSlice";

const FooterContainer = () => {
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const dispatch = useDispatch();

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const validatePhoneNumber = () => {
    let err = {};
    if (!phoneNumber || phoneNumber?.length !== 10) {
      err.phoneNumber = "Please enter a valid 10-digit phone number";
    } else {
      err = {};
    }
    setErrors(err);
    return Object.keys(err).length === 0 ? true : false;
  };

  const handleSendButtonClick = async () => {
    if (validatePhoneNumber()) {
      setIsLoading(true);
      try {
        const payload = {
          phone: phoneNumber,
        };

        const response = await LeadService(payload);
        dispatch(
          openPopup({
            popupId: "thankYouPopup",
          })
        );
      } catch (error) {
        dispatch(showSnackbar(error?.response?.data?.message || "Oops, something went wrong. Please try again later.", "error"));
      } finally {
        setIsLoading(false);
        setPhoneNumber(null);
      }
    }
  };

  const containerProps = {
    socialMediaData: SOCIAL_MEDIA_INFORMATION,
    companySiteData: COMPANY_SITE_DATA,
    companyVehicleSiteData: COMPANY_VEHICLE_SITE_DATA,
    locationInfo: LOCATION_INFO,
    phoneNumber,
    errors,
    isLoading,
  };

  const containerMethods = {
    handleSendButtonClick,
    handlePhoneNumberChange,
  };
  return (
    <Footer
      containerProps={containerProps}
      containerMethods={containerMethods}
    />
  );
};

export default FooterContainer;
